<template>
	<div id="wrapper">
		<SidebarView :coaTransactions="true" :accountsVisible="true" :accounts="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<h6 class="m-0 fw-bold text-green">
										COA Transactions
									</h6>
								</div>
								<div class="d-flex">
									<div>
										<b-button size="sm" class="btn-size akkurate-green-btn"
											@click="showCOAAddModal(null, 'new')" variant="primary">
											<span class="akkurate-small">
												<i class="fas fa-plus"></i> Add
												Transaction</span>
										</b-button>
									</div>
									<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
										<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
									<b-link v-b-modal.tracking title="Track Imbalances"
										class="fw-semibold ms-2 akkurate-green">
										<font-awesome-icon :icon="[
											'fas',
											'magnifying-glass',
										]" /></b-link>
									<b-link v-b-modal.bv-modal-filter title="Re-write Balance"
										class="fw-semibold ms-2 akkurate-green">
										<font-awesome-icon :icon="[
											'fas',
											'arrow-rotate-left',
										]" /></b-link>
								</div>

							</div>
						</div>
						<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115)">
							<div class="home-box border border-success py-1 bg-white">
								<div class="my-1 row text-center">
									<div class="col-12" v-if="this.form.users.length > 0">
										<p class="mb-0 my-1 small">
											Selected Users
											<span class="fw-bold">{{
												coa_name
											}}</span>
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-green" />
											Total Credit <br /><span class="fw-bold">{{
												displayNumber(total_credit)
											}}</span>
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-danger" />
											Total Debit <br /><span class="fw-bold">{{
												displayNumber(total_debit)
											}}</span>
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-grey rounded-circle" />
											Total Balance <br /><span class="fw-bold">{{
												displayNumber(total_balance)
											}}</span>
										</p>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 text-center">
										<div class="akkurate-small">
											{{ getCOASubhead }}
										</div>
									</div>
								</div>
								<hr class="m-0" />
								<div class="card-body pt-0">
									<form @submit.prevent="submitFormFilters()">
										<div class="row">
											<div class="col-12 col-md-4">
												<label class="akkurate-dark small" for="search">Search</label>
												<b-form-group id="search" label-for="search" class="akkurate-dark">
													<b-form-input id="search" class="mt-2 field-container fields"
														type="text" v-model="form.search"
														placeholder="Search by name, code, A/C, phone ...">
													</b-form-input>
												</b-form-group>
											</div>
											<div class="col">
												<label class="akkurate-dark small" for="reference">Reference</label>
												<b-form-group label-for="reference" class="akkurate-dark">
													<b-form-input id="reference" class="mt-1 field-container fields"
														type="text" v-model="form.reference"
														placeholder="Enter Reference">
													</b-form-input>
												</b-form-group>
											</div>
											<div class="col">
												<label class="akkurate-dark small" for="coa_subhead">Chart of
													Account</label>
												<b-form-group id="coa_subhead" label-for="coa_subhead"
													class="akkurate-dark">
													<multiselect v-model="form.coa" :options="coa_options"
														:custom-label="coaSelectLabel
															" :multiple="true" placeholder="Select Coa Subhead(s)" :close-on-select="false" :clear-on-select="false"
														class="mt-2 field-container" track-by="id">
														<template slot="selection">
															<span class="multiselect__single" v-if="form.coa?.length">
																{{
																	form.coa?.length
																}}options selected</span>
														</template>
													</multiselect>
												</b-form-group>
											</div>

											<div
												class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
												<b-button type="submit"
													class="akkurate-green-btn akkurate-auth-size w-100"><i
														class="fas fa-search me-2"></i>Search</b-button>
												<b-button size="sm" v-b-modal.modal-transaction
													title="show more filters" class="ms-2">
													<i class="fas fa-bars akkurate-small"></i>
												</b-button>
											</div>
										</div>
									</form>
								</div>
								<b-modal size="lg" id="modal-transaction" @ok="handleOk">
									<template #modal-title>
										<h6 class="fw-bold mb-0 akkurate-green">
											Filter
										</h6>
									</template>
									<form-filter :form="form" :users="users" :coa_type_options="coa_type_options"></form-filter>
									<template #modal-footer="{ ok }">
										<div class="w-100">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button @click="
												$bvModal.hide(
													'modal-transaction'
												)
												" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'close',
													]" />Cancel
												</span></b-button>
											<b-button @click="ok()" type="submit" :disabled="isSaving"
												class="akkurate-green-btn btn-size float-right border-0"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'search',
													]" />Search</span></b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
						<div class="card-body pt-0 px-0">
							<div class="table_text_size">
								<b-table striped bordered responsive id="allCOATransactionTable" :busy.sync="isLoading"
									:items="rows" :fields="trans_columns" :tbody-tr-class="rowClass" show-empty>
									<template #empty="scope">
										<h4 class="text-center small mt-3">
											{{ scope.emptyText }}
										</h4>
									</template>
									<template #table-busy>
										<div class="text-center text-danger my-2">
											<b-spinner class="align-middle"></b-spinner>
											<strong>Loading...</strong>
										</div>
									</template>
									<template #cell(index)="data">
										{{ data.index + 1 }}
									</template>
									<!-- A custom formatted column -->
									<template #cell(created_user)="data">
										{{
											data.item.created_user?.first_name
										}}
										{{ data.item.created_user?.surname }}
									</template>
									<template #cell(dr_amount)="data">
										{{ displayNumber(data.item.dr_amount) }}
									</template>
									<template #cell(cr_amount)="data">
										{{ displayNumber(data.item.cr_amount) }}
									</template>
									<template #cell(actions)="data">
										<span class="d-flex">
											<a title="Add" v-if="
												data.item.deleted_at == null" class="btn btn-sm text-white akkurate-green-btn border-0 custom-pointer"
												@click="showCOAAddModal(data.item, 'add')">
												<span class="akkurate-small"><font-awesome-icon
														:icon="['fas', 'plus']" /></span>
											</a>
											<a title="Edit" v-if="
												data.item.deleted_at == null
											" class="btn btn-sm text-white akkurate-blue border-0 custom-pointer" @click="
												showCOAEditModal(data.item)
												">
												<span class="akkurate-small"><font-awesome-icon
														:icon="['fas', 'edit']" /></span>
											</a>
											<a title="Delete" v-if="data.item.deleted_at == null && delete_trans"
												class="btn btn-sm akkurate-danger-btn text-white border-0 custom-pointer"
												@click="
													deleteCOATransactions(data.item)" variant="primary">
												<span class="akkurate-small">
													<i class="fas fa-trash"></i></span>
											</a>
											<a title="Restore" v-else-if="restore_trans && data.item.deleted_at != null"
												class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer"
												@click="
													restoreCOATransaction(
														data.item
													)
													" variant="primary">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'arrow-rotate-left',
												]" /></span>
											</a>
										</span>
									</template>
								</b-table>

								<div class="d-flex justify-content-between px-3 pb-3">
									<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
										:total-rows="totalRecords" :per-page="perPage"
										aria-controls="member-table"></b-pagination>
									<div class="col text-end mt-1 akkurate-dark">
										<div>
											{{ currentPage }} - {{ perPage }} of
											{{ totalRecords }}
										</div>
										<b-form-group label="Per Page" label-size="sm" class="mb-0">
											<b-form-select @change="selectPerPage" id="per-page-select"
												v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>

		<!-- AI -->
		<ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
		<b-modal size="lg" id="bv-modal-coa-add" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">
					Add COA Transactions
				</h6>
			</template>
			<add-transaction :coa_data="coa_data" :coa_subhead_options="coa_subhead_options" :trans_type="trans_type"
				@savedAdd="savedAdd"></add-transaction>
		</b-modal>
		<b-modal size="lg" id="bv-modal-coa-edit" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">
					Edit COA Transactions
				</h6>
			</template>
			<edit-transaction :coa_data="coa_data" :coa_subhead_options="coa_subhead_options"
				@savedEdit="savedEdit"></edit-transaction>
		</b-modal>
		<b-modal size="lg" id="bv-modal-filter" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">
					Rewrite COA Balance
				</h6>
			</template>
			<rewrite-transaction @submitRewrite="submitRewrite"></rewrite-transaction>
			<!-- <edit-transaction :coa_edit="coa_edit" :coa_subhead_options="coa_subhead_options"
                @coaSaved="coaSaved"></edit-transaction> -->
		</b-modal>
		<track-imbalance :branch_option="branch_option" @getImbalance="getImbalance"
			:institution="institution"></track-imbalance>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ApiService from "@/core/services/api.service";
import ExcelJS from "exceljs";
import Multiselect from "vue-multiselect";
import { hasPermission } from "@/helper";
import FormFilter from "./FormFilter.vue";
import RewriteTransaction from "./RewriteTransaction.vue";
import AddTransaction from "./forms/AddTransaction.vue";
import EditTransaction from "./forms/EditTransaction.vue";
import TrackImbalance from "./TrackImbalance.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
		FormFilter,
		AddTransaction,
		EditTransaction,
		RewriteTransaction,
		TrackImbalance,
		ChatBot,
	},
	data() {
		return {
			...this.initialState(),
			trans_type: "",
			// code_option: [
			//   { name: "Customer code", value: "filter" },
			//   { name: "Account #", value: "account_number" },
			//   { name: "Ref.No", value: "code" },
			//   { name: "Mobile", value: "phone_number" },
			// ],
			trans_columns: [
				{
					label: "Trans_ID",
					key: "id",
				},
				{
					label: "COA",
					key: "coasubhead.name",
				},
				{
					label: "Reference",
					key: "reference",
				},
				{
					label: "Debit",
					key: "dr_amount",
				},
				{
					label: "Credit",
					key: "cr_amount",
				},
				{
					label: "Receipt_No",
					key: "model_id",
				},
				{
					label: "Entry Type",
					key: "note",
				},
				{
					label: "Trans_Date",
					key: "transaction_date",
				},
				{
					label: "Branch",
					key: "branch.name",
				},
				{
					label: "Trans_Date",
					key: "transaction_date",
				},
				{
					label: "Description",
					key: "transaction_description",
				},
				{
					label: "User",
					key: "created_user",
				},

				{
					label: "Actions",
					key: "actions",
				},
			],
			rows: [],
			currentPage: 1,
			perPage: 10,
			per_page_options: ["10", "20", "50", "100", "500", "1000"],
			reverse_pemission: true,
			total_credit: 0,
			total_debit: 0,
			total_balance: 0,
			coa_subhead_options: [],
			coa_type_options:[],
		};
	},
	mounted() {
		this.getAccountDropdown();
		this.getInsistution();
		this.loadTransactions();
		this.checkPemission();
		const reference = this.$route.query?.reference
		const coa_code = this.$route.query?.coa_code
		if (reference) {
			this.form.reference = reference
			this.loadTransactions();
		}
		if (coa_code) {
			this.form.coa_code = coa_code
			this.loadTransactions();
		}
		const global_reference = this.$route.query?.global_reference
		if (global_reference) {
			this.form.global_reference = global_reference
			this.loadTransactions();
		}
	},
	methods: {
		statusBadge(item) {
			if (item === "COMPLETED") {
				return "badge akkurate-green-bg";
			} else if (item === "FAILED") {
				return "badge akkurate-danger-bg";
			} else if (item === "REVERSED") {
				return "badge akkurate-danger-bg";
			} else if (item === "PENDING") {
				return "badge akkurate-warning-bg";
			} else {
				return "badge akkurate-warning-bg";
			}
		},
		submitFormFilters() {
			this.loadTransactions();
			this.coa_name = this.form.users
				.map((index) => {
					return `${index.first_name} ${index.surname}`;
				})
				.join(", ");
		},
		rowClass() {
			return "custom-row-height";
		},
		filterTable() {
			this.loadTransactions();
		},

		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.loadTransactions();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadTransactions();
		},
		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.submitFormFilters();
		},
		getImbalance(id) {
			console.log(id);
			this.form.search = id;
			this.loadTransactions();
		},
		checkPemission() {
			// console.log(hasPermission())
			this.delete_trans = hasPermission(
				"financial_management_delete"
			);
			this.restore_trans = hasPermission(
				"financial_management_restore"
			);
		},
		savedAdd() {
			this.loadTransactions();
			this.$bvModal.hide("bv-modal-coa-add");
		},
		savedEdit() {
			this.loadTransactions();
			this.$bvModal.hide("bv-modal-coa-edit");
		},
		async getAccountDropdown() {
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					// console.log(response);
					this.branch_option = response.data.branches;
					this.acc_types_option = response.data.account_types;
					this.users = response.data.users;
					this.coa_type_options = response.data.coa_type;
					console.log(this.coa_type_options);
				})
				.catch((error) => {
					// console.log(error);
				});
		},

		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		async loadTransactions(searchFilter = null) {
			this.isLoading = true;
			var coa_subhead = [];
			var model_types = [];
			var coa_types = [];
			if (this.form.coa != []) {
				coa_subhead = this.form.coa.map((index) => index.id) ?? [];
			}
			if (this.form.model_type != []) {
				model_types = this.form.model_type.map((index) => index.id) ?? [];
			}
			if (this.form.coa_type != []) {
				coa_types = this.form.coa_type.map((index) => index.id) ?? [];
			}
			await ApiService.post("/finance/coa-transactions", {
				page: this.currentPage,
				per_page: this.perPage,
				filter: this.form.search,
				users: this.form.users,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				term: this.form.term,
				entry_mode: this.form.entry_mode,
				coa: coa_subhead,
				model_type: model_types,
				global_reference: this.form.global_reference,
				reference: this.form.reference,
				coa_code: this.form.coa_code,
				coa_type: coa_types
			})
				.then((response) => {
					this.rows = response.data.data;
					this.totalRecords = response.data.meta.total;
					this.total_credit = response.data.total_credit;
					this.total_debit = response.data.total_debit;
					this.total_balance = response.data.total_balance;
					this.coa_options = response.data.coa_subheads;
					this.coa_subhead_options = response.data.coa_subheads;
					this.$Progress.finish();
				})
				.catch((error) => {
					this.isLoading = false;
					this.$Progress.fail();
				})
				.finally(() => {
					this.isLoading = false;
					this.$Progress.finish();
				});
		},
		initialState() {
			return {
				totalRecords: 0,
				showViewTransaction: false,
				searchFilter: "",
				coa_name: "",
				delete_trans: false,
				restore_trans: false,
				form: {
					// branch: [],
					start_date: "",
					end_date: "",
					users: [],
					product: [],
					term: "",
					entry_mode: "",
					coa: [],
					model_type: "",
					coa_code: "",
					coa_type:[],
				},
				branch_option: [],
				coa_options: [],
				isLoading: true,
				isSaving: false,
				add_or_edit: "add",
				report_data: {},
				institution: {},
				users: [],
				coa_data: {},
			};
		},
		showCOAAddModal(row, type) {
			this.coa_data = row;
			this.trans_type = type
			this.$bvModal.show("bv-modal-coa-add");
		},
		showCOAEditModal(row) {
			this.coa_data = row;
			this.$bvModal.show("bv-modal-coa-edit");
		},

		viewTransaction(trans) {
			// console.log("Veeeew");
			this.showViewTransaction = true;
		},
		// getCreatedAt(trans) {
		//     return this.removeAfterDot(trans.created_at);
		// },
		// approveWithdrawal(trans) {
		//     swal
		//         .fire({
		//             title: "Approve Withdrawal!",
		//             // title: "Successfull Saved",
		//             text: `Are you sure you want to approve withdrawal transaction ${trans.code}?`,
		//             // text: 'CODE : 14345664565',
		//             confirmButtonColor: "#018673",
		//             icon: "info",
		//             allowOutsideClick: false,
		//             allowEscapeKey: false,
		//             showCancelButton: true, // Show the "Cancel" button
		//             confirmButtonText: "Yes", // Customize the text for the "OK" button
		//             cancelButtonText: "No", // Text for the custom button
		//             buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		//             customClass: {
		//                 confirmButton:
		//                     "btn akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
		//                 cancelButton: "btn akkurate-ash modal-btn-width text-white", // Custom class for the custom button
		//             },
		//         })
		//         .then(async (result) => {
		//             if (result.isConfirmed) {
		//                 await ApiService.post("/transactions/withdrawals/approve", {
		//                     transaction_id: trans.id,
		//                     code: trans.code,
		//                 })
		//                     .then((respp) => {
		//                         toast.fire({
		//                             icon: "success",
		//                             title: respp.data.message,
		//                         });

		//                         this.loadTransactions();
		//                     })
		//                     .catch((error) => {
		//                         if (error.response.data.message) {
		//                             toast.fire({
		//                                 icon: "error",
		//                                 title: error.response.data.message,
		//                             });
		//                         } else {
		//                             toast.fire({
		//                                 icon: "error",
		//                                 title: "An error occurred",
		//                             });
		//                         }
		//                     })
		//                     .finally((resp) => {
		//                         this.isLoading = false;
		//                     });
		//             } else if (result.isDismissed) {
		//             }
		//         });
		// },
		removeAfterDot(inputString) {
			if (inputString.includes(".")) {
				return inputString.split(".")[0];
			}
			return inputString; // If there's no dot, return the original string
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`M${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`M${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`M${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`M${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`M${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`M${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`M${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`M${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("N").width = 50; // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Trans_ID",
					"COA",
					"Reference",
					"Debit",
					"Credit",
					"Receipt_No",
					"Entry",
					"Trans_Date",
					"Branch",
					"Trans_Date",
					"Description",
					"User",
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.rows.forEach((item) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.id,
						item.coasubhead.name,
						item.reference,
						item.dr_amount,
						item.cr_amount,
						item.model_id,
						item.note.mobile,
						item.transaction_date,
						item.branch.name,
						item.transaction_date,
						item.transaction_description,
						item.created_user?.first_name +
						" " +
						item.created_user?.surname,
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Exported_COA_Trans.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		deleteCOATransactions(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>DELETE</strong> Transaction - <strong>${data.id}</strong>?<br/>This action cannot be reversed`,
				icon: "warning",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Delete", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-red-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.delete(
						`/finance/coa-transactions/${data.id}`
					)
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadTransactions();
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
					//
				}
			});
		},
		restoreCOATransaction(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>RESTORE</strong> Transaction - <strong>${data.id}</strong>`,
				icon: "info",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Restore", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-gray-btn modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.post(
						`/finance/coa-transactions/${data.id}/restore`
					)
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadTransactions();
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
					//
				}
			});
		},
		printReceipt(data) {
			// console.log(data.item);
			this.report_data = {
				trans_date: data.trans_date,
				account_number: data.account?.account_number,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				transaction_mode: data.transaction_mode,
				transaction_type: data.transaction_type,
				amount: data.trans_amount,
				cheque_no: "not avaliable",
				bank_name: "not avaliable",
				branch_name: data.branch,
				narration: data.narration,
				institution: this.institution,
				receipt_no: data.id,
				teller:
					data.item?.created_user?.first_name +
					" " +
					data.item?.created_user?.surname,
				denomination: data.denominations,
				mobile: data.mobile,
				network: data.network,
				external_reference: data.external_reference,
				momo_reference: data.momo_reference,
			};
			switch (data.transaction_mode) {
				case "Cash":
					if (data.transaction_type == "Deposit") {
						this.$refs.showCashDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showCashWithdrawal.showModal();
					}

					break;
				case "Cheque":
					if (data.transaction_type == "Deposit") {
						this.$refs.showChequeDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showChequeWithdrawal.showModal();
					}
					break;
				case "Momo":
					if (data.transaction_type == "Deposit") {
						this.$refs.showMomoDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showMomoWithdrawal.showModal();
					}
					break;
				case "Direct Debit":
					if (data.transaction_type == "Deposit") {
						this.$refs.showDirectDebitDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showDirectDebitWithdrawal.showModal();
					}
					break;
			}
		},
		chequePrintout(data) {
			this.report_data = {
				trans_date: data.trans_date,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				amount: data.trans_amount,
				institution: this.institution,
			};
			this.$refs.showChequePrintout.showModal();
		},
		chequeTemplate(data) {
			this.report_data = {
				trans_date: data.trans_date,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				amount: data.trans_amount,
				// institution: this.institution,
			};
			this.$refs.showChequeTemplate.showModal();
		},

		deleteTransaction(index) {
			swal.fire(
				{
					title: "Delete Transactions",
					// text: 'CODE : ' + response.data.transaction.code,
					text: "Are you sure you want to delete this Transaction?",
					confirmButtonColor: "#018673",
					icon: "question",
					type: "input",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				},
				function (inputValue) {
					if (inputValue === null) return false;

					if (inputValue === "") {
						// swal.showInputError("You need to write something!");
						return false;
					}

					// swal("Nice!", "You wrote: " + inputValue, "success");
				}
			).then(async (result) => {
				// this.$Progress.start();
				if (result.isConfirmed) {
					this.isLoading = true;
					await ApiService.delete(
						`/transactions/${index.code}/delete`
					)
						.then((respp) => {
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});

							this.loadTransactions();
						})
						.catch((error) => {
							if (error.response.data.message) {
								toast.fire({
									icon: "error",
									title: error.response.data.message,
								});
							} else {
								toast.fire({
									icon: "error",
									title: "An error occurred",
								});
							}
						})
						.finally((resp) => {
							this.isLoading = false;
						});

					this.loadTransactions();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = false;
					// this.$Progress.finish();
				}
			});
		},
		coaSelectLabel({ name, code, coabranch }) {
			let select_label = `${code ? code : ""} - ${name}`;
			if (coabranch) {
				select_label += `- ${coabranch.name}`;
			}
			return select_label;
		},
		moreAction() {
			this.$bvModal.show("bv-modal-filter");
		},
		submitRewrite() {
			this.loadTransactions();
			this.$bvModal.hide("bv-modal-filter");
		},
	},
	computed: {
		getCOASubhead() {
			if (this.form.coa?.length > 0) {
				const result = this.form.coa.map((index) => {
					return (
						index.code +
						" - " +
						index.name +
						" - " +
						index.coabranch.name
					);
				});
				// console.log(result);
				return result.join(" | "); // Join array elements with ", "
			} else {
				return "";
			}
		},
	},
};
</script>


<style>
#bv-modal-coa-add___BV_modal_content_ {
	border-radius: 0.5rem !important;
}

.modal-header {
	background-color: #EAEFF2 !important;
}
</style>